import { Injectable } from '@angular/core';
import Userback from '@userback/widget';
import type {
  UserbackOptions,
  UserbackWidget,
  UserbackFeedbackType,
  UserbackDestinationType,
  UserbackAfterSendData,
  UserbackWidgetSettings
} from '@userback/widget';
import { helpWidgetConfig } from '../misc/help-widget.constant';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserbackService {
  private ready = false;
  private queue: (() => void)[] = [];
  private widget!: UserbackWidget;
  private helpCenterWidgetEnableSubject = new BehaviorSubject<boolean>(false);
  helpCenterWidgetEnable$: Observable<boolean> =
    this.helpCenterWidgetEnableSubject.asObservable();

  init(userData: any): void {
    if (typeof window === 'undefined') return;

    const options: UserbackOptions = {
      widget_settings: helpWidgetConfig.userback.widgetSettings as UserbackWidgetSettings,
      user_data: userData,
      on_load: () => {
        this.ready = true;
        this.queue.forEach(fn => fn());
        this.queue = [];
        this.hideLauncher();
      },
      on_close: () => {
        this.hideLauncher();
      },
      after_send: (data: UserbackAfterSendData) => {
        this.hideLauncher();
      }
    };
    Userback(this.getUserbackToken(), options)
      .then(widget => {
        this.widget = widget;
      })
      .catch(err => {
        console.error('Userback init failed', err);
      });
  }

  showLauncher() {
    if (!this.widget) return;
    this.widget.showLauncher();
  }

  hideLauncher() {
    if (!this.widget) return;
    this.widget.hideLauncher();
  }

  closeFeedback() {
    if (!this.widget) return;
    this.widget.close();
  }

  openFeedback(type: UserbackFeedbackType): void {
    const run = () => {
      try {
        if (!this.widget) {
          throw new Error('Userback widget is not initialized');
        }
        this.showLauncher();
        const destination: UserbackDestinationType = type === 'bug' ? 'screenshot' : 'form';
        this.widget.open(type, destination);
      } catch (error) {
        console.error('Error opening feedback:', error);
        throw error;
      }
    };

    this.ready ? run() : this.queue.push(run);
  }

  initUserback(): void {
    this.init(
      {
        id: localStorage.getItem('userId') || '',
        info: {
          name: JSON.parse(localStorage.getItem('userName')) || '',
          email: localStorage.getItem('userEmailId') || '',
          customer_id: localStorage.getItem('customerId') || '',
          tenant_domain: localStorage.getItem('DomainName') || ''
        }
      }
    );
  }

  getDocsToken() {
    return localStorage.getItem('supportPageToken') ;
  }

  getUserbackToken() {
    return localStorage.getItem('userbackToken') ;
  }

  isUserbackReady(): boolean {
    return this.ready;
  }

  setHelpCenterWidgetEnable(value: boolean): void {
    this.helpCenterWidgetEnableSubject.next(value);
  }

  logoutUserback(): void {
    if (this.widget) {
      try {
        this.widget.destroy();
      } catch (e) {
        console.warn('Userback destroy failed', e);
      }
    }
    this.widget = undefined as any;
    this.ready = false;
    this.queue = [];
  }

}
